import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react"

const apiService = createApi({
  reducerPath: "api",
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_APIURL}`,
    prepareHeaders: (headers, { getState }) => {
      try {
        const token = sessionStorage.getItem("accessToken")
        if (token) {
          headers.set("authorization", token)
        }
        headers.set("ngrok-skip-browser-warning", 1)
      } catch (err) {}

      // If we have a token set in state, let's assume that we should be passing it.

      return headers
    },
  }),
  endpoints: (builder) => ({
    login: builder.mutation({
      query: (credentials) => ({
        url: "user/login",
        method: "POST",
        body: credentials,
      }),
    }),
    forgotPasswordLink: builder.mutation({
      query: (email) => ({
        url: "user/forgotPasswordRequest",
        method: "POST",
        body: { email },
      }),
    }),
    resetPasswordUpdate: builder.mutation({
      query: ({ password: newPassword, token }) => ({
        url: `user/resetForgottenPassword/${token}`,
        method: "POST",
        body: { newPassword },
      }),
    }),
    getUserDetails: builder.query({
      query: () => ({
        url: "user",
        method: "GET",
      }),
      transformResponse: (response, meta, arg) => response.data,
    }),
  }),
})

export const {
  useLoginMutation,
  useLazyGetUserDetailsQuery,
  useForgotPasswordLinkMutation,
  useResetPasswordUpdateMutation,
} = apiService
export default apiService
